import React from "react";
import { BsLinkedin } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import { BsFacebook } from "react-icons/bs";

function HeaderSocials() {
  return (
    <div className="header__socials">
      <a
        href="https://www.linkedin.com/in/aliammari68/"
        target="_blank"
      >
        <BsLinkedin />
      </a>
      <a href="https://github.com/aliammari1/" target="_blank">
        <FaGithub />
      </a>
      <a href="https://www.facebook.com/ali.ammari.9465/" target="_blank">
        <BsFacebook />
      </a>
    </div>
  );
}

export default HeaderSocials;
